import { wencesApi } from "@/api/wencesApi";
import { checkAuthAction } from "../actions/check-auth.action";
import { syncI18nLocaleFromUser } from "@/i18n";

function userPermissionMatches(userPermLower, requiredDot) {
  const normalizedPermission = String(requiredDot || "").toLowerCase().trim();
  const parts = normalizedPermission.split(".");
  const model = parts[0];
  const action = parts[1];
  if (!model || !action) {
    return userPermLower === normalizedPermission;
  }
  const formats = [
    normalizedPermission,
    `${model}_${action}`,
    `${model} - ${action}`,
    `${model}_manage`,
    `${model}.manage`,
  ];
  return formats.includes(userPermLower);
}

function hasUsersSettingsAccess(permissions) {
  const list = Array.isArray(permissions) ? permissions : [];
  const lower = list.map((p) => String(p || "").toLowerCase());
  if (lower.includes("all_access")) {
    return true;
  }
  for (const p of lower) {
    if (
      userPermissionMatches(p, "users.view") ||
      userPermissionMatches(p, "users.manage") ||
      userPermissionMatches(p, "users.edit")
    ) {
      return true;
    }
  }
  return false;
}

/**
 * Misma regla que permissionsMixin.canAccessUsersSettings (listado /users).
 */
export default async function canAccessUsersSettingsGuard(to, from, next) {
  const token = localStorage.getItem("token");
  if (!token) {
    next("/login");
    return;
  }

  try {
    const statusResp = await checkAuthAction();
    if (statusResp.transient) {
      syncI18nLocaleFromUser(undefined);
      next();
      return;
    }
    if (!statusResp.ok) {
      next("/login");
      return;
    }
    syncI18nLocaleFromUser(statusResp.user);
    if (statusResp.needsToAcceptTerms) {
      localStorage.setItem("pendingRoute", to.fullPath);
      next("/login");
      return;
    }

    const profileResponse = await wencesApi.get("/api/users/myprofile", {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!profileResponse.data.ok) {
      next("/dashboard");
      return;
    }

    const userData = profileResponse.data.data;
    let roleId;
    if (typeof userData.role === "string") {
      roleId = userData.role;
    } else if (userData.role && userData.role._id) {
      roleId = userData.role._id;
    }

    if (!roleId) {
      next("/dashboard");
      return;
    }

    const roleResponse = await wencesApi.get(`/api/roles/${roleId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (
      !roleResponse.data.success ||
      !roleResponse.data.data ||
      !Array.isArray(roleResponse.data.data.permissions)
    ) {
      next("/dashboard");
      return;
    }

    if (hasUsersSettingsAccess(roleResponse.data.data.permissions)) {
      next();
    } else {
      next("/dashboard");
    }
  } catch (error) {
    console.error("canAccessUsersSettingsGuard:", error);
    next("/login");
  }
}
